import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './DirectoresReports.css';
import renderHTML from 'react-render-html';
import { useParams } from "react-router-dom";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function DirectoresReports() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [nameCom, setNameCom] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const [data, setData] = useState([]);
    const { getCompName } = useParams();
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [co_code, setco_code] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (co_code != '') {
            const getUrl = BaseURL + "DirectoresReports";
            fetch(`${getUrl}/${co_code}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }

    }, [co_code]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);
    // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }

    // const handleClick = () => {
    //     const getUrl = BaseURL + "DirectoresReports";
    //     fetch(`${getUrl}/${compCode}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             getData = data.data;
    //             setData(getData);
    //             console.log(getData, "getData")
    //         })
    //         .catch((error) => {
    //         });
    // }

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Directors Reports</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='directores-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Directors Report</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Directors Reports" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            {/* <div>
                                <div className='quotes-main-comp'>
                                    <input type="text" placeholder='Enter Company Name' onChange={onChangeHandler} ></input>
                                    {showResults ?
                                        <div className="suggestion">
                                            {suggestions && suggestions.map((suggestion, i) =>
                                                <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.COCODE, suggestion.CompName, suggestion.Exchange)}>{suggestion.CompName}</div>
                                            )}
                                        </div> : ''}
                                </div>
                                <div className='get-quote-btn'>
                                    <button className="goComp-comp" onClick={handleClick}>GO</button>
                                </div>
                            </div> */}
                            <div className="table-classDir">

                                {/* tabIndex={0} */}
                                <div className="share-table table-responsive" tabIndex={0}>

                                    {currentTableData && currentTableData.map(
                                        ({ DIRECTORREP }) => (
                                            <div>{renderHTML(DIRECTORREP)}</div>
                                        ))}

                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }
                                </div>
                            </div>

                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <h5 className="errorPeer"> No Data Found !!!</h5>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default DirectoresReports;